function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Animated, StyleSheet, View } from 'react-native';
const styles = StyleSheet.create({
  main: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
});
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}

const SIZE = 3;
const MARGIN = 5;
const BG = 'rgb(172, 172, 172)';
const ACTIVE_BG = '#808184';
const dots = [1, 2, 3];
const INTERVAL = 300;
const ANIMATION_DURATION = 400;
const ANIMATION_SCALE = 1.4;
const DotFlashing = props => {
  const [active, setActive] = useState({
    active: 1
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setActive(prevState => ({
        active: prevState.active > 2 ? 1 : prevState.active + 1
      }));
    }, INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: styles.main
  }, dots.map(i => /*#__PURE__*/React.createElement(Dot, _extends({}, props, {
    active: i === active.active
  }))));
};
const Dot = _ref => {
  let {
    active,
    size = SIZE,
    background = BG,
    activeBackground = ACTIVE_BG,
    dotMargin = MARGIN,
    animationDuration = ANIMATION_DURATION,
    animationScale = ANIMATION_SCALE
  } = _ref;
  const scale = useMemo(() => {
    return new Animated.Value(1);
  }, []);
  const prevActive = usePrevious(active);
  const scaleDown = useCallback(() => {
    Animated.timing(scale, {
      toValue: 1,
      duration: animationDuration,
      useNativeDriver: false
    }).start();
  }, [animationDuration, scale]);
  const scaleUp = useCallback(() => {
    Animated.timing(scale, {
      toValue: animationScale,
      duration: animationDuration,
      useNativeDriver: false
    }).start();
  }, [animationDuration, scale, animationScale]);
  useEffect(() => {
    if (active) scaleUp();
  }, [active, scaleUp]);
  useEffect(() => {
    if (prevActive && !active) scaleDown();
    if (!prevActive && active) scaleUp();
  }, [active, prevActive, scaleDown, scaleUp]);
  const style = {
    height: size,
    width: size,
    borderRadius: size / 2,
    marginHorizontal: dotMargin,
    backgroundColor: active ? activeBackground : background
  };
  return /*#__PURE__*/React.createElement(Animated.View, {
    style: [style, {
      transform: [{
        scale
      }]
    }]
  });
};
Dot.defaultProps = {
  size: SIZE,
  background: BG,
  activeBackground: ACTIVE_BG,
  dotMargin: MARGIN,
  animationDuration: ANIMATION_DURATION,
  animationScale: ANIMATION_SCALE
};
export default DotFlashing;
//# sourceMappingURL=DotFlashing.js.map